(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.view :as esg]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.view
    :refer [portfolio-locations-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]))

(defn resi-section
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name
                overview
                map-data
                portfolio-summary-text
                portfolio-overview
                recent-development-text]}
        holding-ui-data]
    [section
     holding-name
     nil
     [:div
      [grid/row {}
       [grid/column {:span 12}
        [card
         {:title ""}
         [:<>
          [free-text-card/free-text-section "Case overview" portfolio-summary-text props]
          [free-text-card/free-text-section "Recent Developments" recent-development-text props]]
         [:div
          (tabular-card/dynamic-stacked-table overview props)
          [portfolio-locations-card map-data props]]]]]
      [grid/row {}
       [grid/column {:span 12}
        [tabular-card/dynamic-table "Investment overview" portfolio-overview props]]]]]))

(defn stockholm-living-section
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name
                overview
                portfolio-summary-text
                portfolio-overview]}
        holding-ui-data]
    [section
     holding-name
     nil
     [:div
      [grid/row {}
       [grid/column {:span 12}
        [card
         {:title ""}
         [:<>
          [free-text-card/free-text-section "Case overview" portfolio-summary-text props]]
         [:div
          (tabular-card/dynamic-stacked-table overview props)]]]]
      [grid/row {}
       [grid/column {:span 12}
        [tabular-card/dynamic-table "Investment overview" portfolio-overview props]]]]]))

(defn resi
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [resi-section props]])

(defn property-esg
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [resi-section props]
   [esg/esg-section holding-ui-data props]])

(defn stockholm-living
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [stockholm-living-section props]
   [esg/esg-section holding-ui-data props]])

(defn portfolio-esg
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [resi-section props]
   [esg/portfolio-esg-section holding-ui-data props]])
